<div class="listing-loader-wrapper">
  <base-loader-dot></base-loader-dot>
</div>
